/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';

const isNotLegacyCards = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'LEGACY_CARDS',
]);

const isNotModeManual = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'cards_contentProducts.mode',
  (value) => value && value !== 'manual',
]);

const isNotModeDynamic = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'cards_contentProducts.mode',
  (value) => !value || value !== 'dynamic',
]);

export default [
  ...[
    getFilterWithCol(['FieldRadio', {
      name: 'cards_contentProducts.mode',
      label: null,
      choices: [
        { value: 'manual', label: 'Manual' },
        { value: 'dynamic', label: 'Dynamic' },
      ],
      initialValue: 'manual',
      block: true,
    }], 24),
    getFilterWithCol(['FieldSortableList', {
      name: 'cards_contentProducts.items',
      label: null,
      addButtonLabel: 'Add Product',
      shouldRenderPlaceholder: true,
      skip: [
        isNotModeManual,
      ],
      head: 'horizontal',
      condensed: true,
      fields: [
        ['FieldConnectionSelect', {
          name: 'product',
          label: null,
          url: '/products',
          placeholder: 'Product',
          getExtraQueryConditions: (props) => [{
            store: (
              props.forms[props.forms.length - 1]?.getFieldValue('store')
              || props?.viewer?.store
            ),
          }],
          searchPaths: ['name'],
        }],
      ],
    }], 24),
    getFilterWithCol(['FieldRadio', {
      name: 'cards_contentProducts.featuredOnSale',
      label: null,
      initialValue: null,
      choices: [
        { value: null, label: 'All' },
        { value: 'ON_SALE', label: 'On Sale Only' },
        { value: 'FEATURED', label: 'Featured Only' },
        { value: 'FEATURED_ON_SALE', label: 'Featured And On Sale' },
      ],
      skip: [
        isNotModeDynamic,
      ],
      block: true,
    }], 24),
    getFilterWithCol(['FieldConnectionSelect', {
      name: 'cards_contentProducts.categories',
      label: null,
      prefix: 'Categories:',
      mode: 'multiple',
      url: '/categories',
      getExtraQueryConditions: (props) => [{
        store: props.forms[0]?.getFieldValue('store') || props?.viewer?.store,
      }],
      searchPaths: ['name'],
      skip: [
        isNotModeDynamic,
      ],
    }], 24),
    getFilterWithCol(['FieldSelect', {
      name: 'cards_contentProducts.sortBy',
      label: null,
      prefix: 'Sort By:',
      initialValue: 'createdAt',
      choices: [
        { value: 'createdAt', label: 'Date Created' },
        { value: 'price', label: 'Price' },
      ],
      skip: [
        isNotModeDynamic,
      ],
      block: true,
    }], 12),
    getFilterWithCol(['FieldSelect', {
      name: 'cards_contentProducts.sortDirection',
      label: null,
      prefix: 'Sort Direction:',
      initialValue: 'DESC',
      choices: [
        { value: 'ASC', label: 'Ascending' },
        { value: 'DESC', label: 'Descending' },
      ],
      skip: [
        isNotModeDynamic,
      ],
      block: true,
    }], 12),
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotLegacyCards, ...(fieldConfig.preSkip || [])],
    },
  ])),
];
